class MiniCartPopup extends HTMLElement {
  constructor () {
    super();

    this.header = document.querySelector('header');
  }

  connectedCallback() {
    document.addEventListener('mini-cart-popup:rerender', this.popupRerender.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener('mini-cart-popup:rerender', this.popupRerender.bind(this));
  }

  popupRerender (event) {
    const popupMarkup =  event.detail.sections['mini-cart-popup'];
    const html = new DOMParser().parseFromString(popupMarkup, 'text/html');

    this.replaceWith(html.querySelector('mini-cart-popup'));
    document.querySelector('.js-cart-toggle span').textContent = html.querySelector('[data-cart-total]').textContent;

    this.header.classList.remove('scrolled');
    this.reinitPopup();
  }

  reinitPopup () {
    const cartToggle = document.querySelector('.js-cart-toggle');
    const miniCart = document.querySelector('.mini-cart');
    const miniCartClose = document.querySelectorAll('.js-cart-close');
    if (cartToggle && miniCart) {
      cartToggle.addEventListener('click', function(e) {
        const nav = document.querySelector('.header__nav');
        const navToggle = document.querySelector('.nav-toggle');
        nav.classList.remove('active');
        navToggle.classList.remove('active');
        miniCart.classList.toggle('open');
      });

      miniCart.addEventListener("mouseleave", (event) => {
        event.preventDefault();
        setTimeout(() => {
          miniCart.classList.remove('open');
        }, 8000);
      })

      cartToggle.addEventListener('mouseenter', function (e) {
        const nav = document.querySelector('.header__nav');
        const navToggle = document.querySelector('.nav-toggle');
        nav.classList.remove('active');
        navToggle.classList.remove('active');
        miniCart.classList.add('open');
      });

      document.addEventListener( 'click', ( e ) => {
        if (!e.target.closest( '.mini-cart' ) && !e.target.classList.contains( 'js-cart-toggle' ) && !e.target.closest( '.js-cart-toggle' )) {
          miniCart.classList.remove('open');
          enableScroll('.header__nav');
        }
      });
    }
    if (miniCartClose) {
      miniCartClose.forEach( btn => {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          miniCart.classList.remove('open');
        });
      });
    }

    cartToggle.click();
  }
}

customElements.define('mini-cart-popup', MiniCartPopup);


class AtcButton extends HTMLElement {
  constructor () {
    super();

    this.submitForm = this.querySelector('form');
    this.variantId = this.submitForm.querySelector('input[name="id"]')
    this.quantity = this.submitForm.querySelector('input[name="quantity"]')
  }

  connectedCallback() {
    this.submitForm.addEventListener('submit', this.handleSubmit.bind(this));
  }

  handleSubmit (event) {
    event.preventDefault();

    let formData = {
      'items': [{
        'id': this.variantId.value,
        'quantity': this.quantity.value
      }],
      'sections': 'mini-cart-popup'
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .then(data => {
      document.documentElement.dispatchEvent(
        new CustomEvent("mini-cart-popup:rerender", {
          detail: data,
          bubbles: true
        })
      )
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

customElements.define('atc-button', AtcButton);


class DesktopFilters extends HTMLElement {
  constructor () {
    super();

    this.overlay = document.querySelector('.js-overlay');
  }

  get sectionId () {
    return this.dataset.sectionId;
  }

  connectedCallback () {
    this.filterInputs = this.querySelectorAll('input');
    this.handleClick = this.handleClick.bind(this);
    this._onFacetClear = this._onFacetClear.bind(this);

    document.addEventListener('facet:clear', this._onFacetClear);

    this.filterInputs.forEach(input => {
      input.addEventListener('change', this.handleClick);
    });
  }

  disconnectedCallback() {
    document.removeEventListener('facet:clear', this._onFacetClear);

    this.filterInputs.forEach(input => {
      input.removeEventListener('change', this.handleClick);
    });
  }

  _onFacetClear(event) {
    const url = event.detail.url;
    this.fetchAndRender(url.toString());
  }

  handleClick(event) {
    const input = event.currentTarget;

    const url = new URL(
      input.checked ? input.dataset.addUrl : input.dataset.removeUrl, 
      window.location.origin
    );
    
    url.searchParams.set('section_id', this.sectionId);

    this.fetchAndRender(url.toString());
  }

  fetchAndRender(url) {
    this.overlay.classList.add('is-visible');

    fetch(url)
      .then(r => r.text())
      .then(htmlString => {
        const html = new DOMParser().parseFromString(htmlString, 'text/html');

        document.querySelector('.collection').innerHTML = html.querySelector('.collection').innerHTML;

        this.reinitFiltersPopups();
        this.reinitMobFiltersTrigger();

        const u = new URL(url);
        u.searchParams.delete('section_id');
        window.history.pushState({}, '', u.toString());
      })
      .finally(() => {
        this.overlay.classList.remove('is-visible');
        document.body.classList.remove("no-scroll");
      });
  }

  reinitFiltersPopups () {
    const items = document.querySelectorAll(".collection-grid__filters-list_item");

    items.forEach((item) => {
      const isToggle = item.classList.contains("toggle");
      const bioToggleInput = item.querySelector('input#bio-toggle') || null;

      item.addEventListener("click", (e) => {
        // Ignore clicks inside details
        if (e.target.closest(".collection-grid__filters-list_item_content")) return;

        e.preventDefault();

        // 1️⃣ If this is a NORMAL item:
        if (!isToggle) {
          // Close ONLY other normal items
          items.forEach((el) => {
            if (el !== item && !el.classList.contains("toggle")) {
              el.classList.remove("is-open");
            }
          });

          // Toggle itself
          item.classList.toggle("is-open");
        }

        // 2️⃣ If this is a TOGGLE item
        else {
          // Toggle ONLY itself
          item.classList.toggle("is-open");
          // Do NOT close anything else
        }

        // BIO toggle logic
        if (bioToggleInput) {
          bioToggleInput.checked = !bioToggleInput.checked;
          bioToggleInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    // 3️⃣ Clicking outside closes ONLY normal items
    document.addEventListener("click", (e) => {
      const isInside = e.target.closest(".collection-grid__filters-list_item");

      if (!isInside) {
        items.forEach((item) => {
          if (!item.classList.contains("toggle")) {
            item.classList.remove("is-open");
          }
        });
      }
    });
  }

  reinitMobFiltersTrigger () {
    const drawer = document.querySelector(".collection-grid__filters-list-mobile-wrapper");
    const overlay = document.querySelector(".js-overlay");
    const openBtn = document.querySelector(".js-open-mobile-filters");
    const closeBtn = document.querySelector(".collection-grid__filters-list-mobile-header__close");

    const submenuPanels = document.querySelectorAll(".mobile-filter-submenu");

    // MAIN DRAWER OPEN
    openBtn.addEventListener("click", () => {
      drawer.classList.add("is-open");
      overlay.classList.add("is-visible");
      document.body.classList.add("no-scroll");
    });

    function closeDrawer() {
      drawer.classList.remove("is-open");
      overlay.classList.remove("is-visible");
      document.body.classList.remove("no-scroll");

      submenuPanels.forEach(panel => panel.classList.remove("is-open"));
    }

    closeBtn.addEventListener("click", closeDrawer);
    overlay.addEventListener("click", closeDrawer);

    // SUBMENU OPEN
    document.querySelectorAll(".js-filter-category").forEach(item => {
      item.addEventListener("click", () => {
        const target = item.dataset.filter;
        const submenu = document.querySelector(`#submenu-${target}`);

        if (submenu) submenu.classList.add("is-open");
      });
    });

    // SUBMENU CLOSE
    document.querySelectorAll(".mobile-filter-submenu__back").forEach(btn => {
      btn.addEventListener("click", () => {
        btn.closest(".mobile-filter-submenu").classList.remove("is-open");
      });
    });
  }
}

customElements.define('desktop-filters', DesktopFilters);


class MobileFilters extends HTMLElement {
  connectedCallback () {
    this.filterInputs = this.querySelectorAll('input');
    this.applyButtons = [...this.querySelectorAll('.collection-grid__filters-list-mobile-footer__button-apply, .collection-grid__filters-list-mobile-footer__button-reset')];

    this.applyFilters = this.applyFilters.bind(this);

    this.filterInputs.forEach(filterInput => filterInput.addEventListener('change', this.filterChange));
    this.applyButtons.forEach(applyButton => applyButton.addEventListener('click', this.applyFilters));
  }

  disconnectedCallback() {
    this.filterInputs.forEach(filterInput => filterInput.removeEventListener('change', this.filterChange));
    this.applyButtons.forEach(applyButton => applyButton.removeEventListener('click', this.applyFilters))
  }

  filterChange(e) {
    const { checked: isChecked, name, value } = e.currentTarget;
    const queryParam = `${name}=${encodeURIComponent(value)}`;

    const params = new URLSearchParams(window.location.search).toString().split('&');
    let newParams = isChecked ? [...params, queryParam] : [...params].filter(param => param != queryParam);
    newParams = [...newParams].filter(param => !param.includes('page='));
    
    history.replaceState(null, '', '?' + newParams.join('&'));
  }

  applyFilters (e) {
    e.preventDefault();
    const target = e.currentTarget;

    const url = target.hasAttribute('data-filter-apply') ? window.location.href : `${window.location.origin}${target.getAttribute('data-reset-url')}`;

    document.documentElement.dispatchEvent(
      new CustomEvent("facet:clear", {
        detail: { url },
        bubbles: true
      })
    );
  }
}

customElements.define('mobile-filters', MobileFilters);


class FacetClear extends HTMLElement {
  connectedCallback() {
    this.resetFacet = this;
    if (!this.resetFacet) return;

    this._onClick = this._onClick.bind(this);
    this.resetFacet.addEventListener('click', this._onClick);
  }

  disconnectedCallback() {
    if (this.resetFacet) {
      this.resetFacet.removeEventListener('click', this._onClick);
    }
  }

  _onClick () {
    const url = new URL(
      this.resetFacet.dataset.removeUrl, 
      window.location.origin
    );

    document.documentElement.dispatchEvent(
      new CustomEvent("facet:clear", {
        detail: { url },
        bubbles: true
      })
    )
  }
}

customElements.define('facet-clear', FacetClear);


class CartSection extends HTMLElement {
  constructor() {
    super();

    this.cartRerender = this.cartRerender.bind(this);
  }

  connectedCallback() {
    document.addEventListener('cart-section:rerender', this.cartRerender);
  }

  disconnectedCallback() {
    document.removeEventListener('cart-section:rerender', this.cartRerender);
  }

  async cartRerender(event) {
    const cartMarkup =  event.detail.sections['cart'];
    const html =  new DOMParser().parseFromString(cartMarkup, 'text/html');
    const price = html.querySelector('.cart-summary__price span').textContent;

    document.querySelector('.js-cart-toggle span').textContent = price;
    this.replaceWith(html.querySelector('cart-section'));
  }
}

customElements.define('cart-section', CartSection);


class CartItem extends HTMLElement {
  constructor() {
    super();

    this.changeQuantityBtns = this.querySelectorAll('.product-summary__minus, .product-summary__plus');
    this.input = this.querySelector('[type="number"]');
    this.delete = this.querySelector('.cart-item__qty a.btn');
    this.changeQuantity = this.changeQuantity.bind(this);
  }

  get key () {
    return this.dataset.key
  }

  connectedCallback() {
    this.changeQuantityBtns.forEach(button => button.addEventListener('click', this.changeQuantity));
    this.delete.addEventListener('click', this.changeQuantity);
  }

  disconnectedCallback () {
    this.changeQuantityBtns.forEach(button => button.removeEventListener('click', this.changeQuantity));
    this.delete.removeEventListener('click', this.changeQuantity);
  }

  async changeQuantity(e) {
    e.preventDefault();
    this.setInputValue(e);

    const data = await this.updateCart(this.input.value);

    document.documentElement.dispatchEvent(
      new CustomEvent("cart-section:rerender", {
        detail: data,
        bubbles: true
      })
    );
  }

  setInputValue(e) {
    const action = e.currentTarget.dataset.action;

    switch (action) {
      case 'minus':
        this.input.value = +this.input.value + -1;
        break;
      case 'plus':
        this.input.value = +this.input.value + 1;
        break;
      case 'delete':
        this.input.value = 0;
        break;
    }
  }

  async updateCart(quantity) {
    let formData = {
      updates: {
        [this.key]: quantity
      },
      sections: 'cart'
    };

    try {
      const response = await fetch(`${window.routes.cart_url}/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      return await response.json()
    } catch (error) {
      console.error('Error:', error);
    }
  }
}

customElements.define('cart-item', CartItem);


class BannerForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');

    if (!this.form) return;

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  connectedCallback() {
    this.form?.addEventListener('submit', this.handleSubmit);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.handleSubmit);
  }

  handleSubmit(e) {
    e.preventDefault();

    const form = this.form;
    const data = new FormData(form);

    this.subscribeToKlaviyo(data, form);
  }

  async subscribeToKlaviyo(data, form){
    try {
      const request = await fetch('https://a.klaviyo.com/ajax/subscriptions/subscribe', {
        method: 'POST',
        body: data
      });

      if (request.status === 200) {
        const results = await request.json()
        
        if (results.success) {
          console.log("success");
          
          form.reset();

          form.classList.add('success');
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
}

customElements.define('banner-form', BannerForm);


class ContactForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');

    if (!this.form) return;

    this.submitBtn = this.form.querySelector('button[type="submit"]');
    this.inputFields = this.form.querySelectorAll('input[type="email"], input[type="text"], textarea, input[type="checkbox"]');
    this.validateForm = this.validateForm.bind(this);
    this.succcessMessage = this.form.querySelector('.success-message');
  }

  connectedCallback() {
    this.submitBtn?.addEventListener('click', this.validateForm);

    if (sessionStorage.getItem('contact_form_submitted') === '1') {
      this.succcessMessage.classList.remove('hidden');
      sessionStorage.removeItem('contact_form_submitted');
    }
  }

  disconnectedCallback() {
    this.submitBtn?.removeEventListener('click', this.validateForm);
  }

  validateForm(e) {
    e.preventDefault();

    this.inputFields.forEach(field => {
      field.classList[field.checkValidity() ? 'remove': 'add']('error');
    });

    if (this.form.checkValidity()) {
      this.form.submit();

      sessionStorage.setItem('contact_form_submitted', '1');
    }
  }
}

customElements.define('contact-form', ContactForm);